import { getUserInfo, getOEMInformation } from '@/requests/user';
import { getBarGroupList } from '@/requests/bar';
export default {
  namespaced: true,
  state: {
    statement: '',
    username: '',
    phone: '',
    smsCode: '',
    userInfo: {
      passportName: '',
      phone: '',
      wxBind: false,
      saveType: 0,
      passportMail: '',
      personalName: '',
      personalQQ: '',
      companyName: '',
      cityId: null,
      address: '',
      registerTime: '',
      hasEditBar: null, //  修改网吧资料
      hasMonitorCenter: null, // 监控中心
      hasRegisterBar: null, //  注册网吧ID
      hasRemote: null, //  远程控制
      passportType: 0, // 账号类型，0是主账号，2是子账号，3是业主账号
      judgeVip: 0, // 0  免费版未开通svip试用   1  免费版已开通svip试用  2  vip  3  svip
      vipStatus: '', // 会员状态
      expireDate: '', // 到期时间
    },
    barGroupList: [],
    selectedBarGroupName: '',
    selectedBarGroupTotal: 0,
    selectedBarGroupOnline: 0,
    oemInfo: {
      id: '',
      webTitle: '',
      beforeLoginLogo: '',
      afterLoginLogo: '',
      domainType: '',
      domainName: '',
    },
    isCanUseClient: false,
    isCanUseShareRules: false,
    isCanDebug: false,
    isDebugAll: false,
    isCanRecord: false,
    notice: false,
    isShowProcess: false,
    isShowDll: false,
    isCanUseTreeHistory: false,
    isNoMax: false
  },
  // getters:{
  //     safeLevel(state){
  //         let level=1
  //         if(state.userInfo.wxBind == true){
  //             level++
  //         }
  //         if(state.userInfo.saveType == 1){
  //             level++
  //         }
  //         return level
  //     }
  // },
  getters: {
    allBarNumInfo: (state) => {
      let total = 0;
      let online = 0;
      state.barGroupList.forEach((item) => {
        total += item.totalBarCnt;
        online += item.activeBarCnt;
      });
      return {
        total,
        online,
      };
    },
  },
  mutations: {
    setIsShowProcess (state, data) {
      state.isShowProcess = data;
    },
    setUsername (state, name) {
      state.username = name;
    },
    setStatement (state, statement) {
      state.statement = statement;
    },
    setPhone (state, phone) {
      state.phone = phone;
    },
    setSmsCode (state, smsCode) {
      state.smsCode = smsCode;
    },
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo;
      if (userInfo.passportType == 0) {
        state.userInfo.hasEditBar = true;
        state.userInfo.hasMonitorCenter = true;
        state.userInfo.hasRegisterBar = true;
        state.userInfo.hasRemote = true;
      }
      userInfo.rolePermission.forEach((val) => {
        if (val.permissionId == '安全中心客户端下载') {
          state.isCanUseClient = true;
        }
        if (val.permissionId == '共享规则库') {
          state.isCanUseShareRules = true;
        }
        if (val.permissionId == '调试模式') {
          state.isCanDebug = true;
        }
        if (val.permissionId == '全网调试') {
          state.isDebugAll = true;
        }
        if (val.permissionId == '调试日志') {
          state.isCanRecord = true;
        }
        if (val.permissionId == '公告') {
          state.notice = true;
        }
        if (val.permissionId == 'dll和开机通道') {
          state.isShowDll = true;
        }
        if (val.permissionId == '全网调试') {
          state.isCanUseTreeHistory = true;
        }
        if (val.permissionId == '上传文件不限制大小') {
          state.isNoMax = true
        }
      });
    },
    setUOEMInfo (state, oemInfo) {
      if (oemInfo) {
        state.oemInfo = oemInfo;
      }
    },
    setBarGroupList (state, list) {
      state.barGroupList = list;
    },
    setSelectedBarGroupName (state, id) {
      state.barGroupList.forEach((item) => {
        if (item.groupId == id) {
          state.selectedBarGroupName = item.groupName;
          state.selectedBarGroupTotal = item.totalBarCnt;
          state.selectedBarGroupOnline = item.activeBarCnt;
        }
      });
    },
  },
  actions: {
    // 展示编辑单个直播视频
    actionSetIsShowProcess ({ commit }, name) {
      commit('setIsShowProcess', name);
    },
    actionSetUsername ({ commit }, name) {
      commit('setUsername', name);
    },
    actionSetStatement ({ commit }, statement) {
      commit('setStatement', statement);
    },
    actionSetPhone ({ commit }, phone) {
      commit('setPhone', phone);
    },
    actionSetSmsCode ({ commit }, smsCode) {
      commit('setSmsCode', smsCode);
    },
    async actionSetUserInfo ({ commit }) {
      let res = await getUserInfo();
      if (res.code == 200) {
        commit('setUserInfo', res.data);
      }
    },
    async actionSetOEMInfo ({ commit }) {
      let res = await getOEMInformation();
      if (res.code == 200) {
        commit('setUOEMInfo', res.data);
      }
    },
    async actionUpdateBarGroupList ({ commit }) {
      let list = await getBarGroupList();
      commit('setBarGroupList', list);
    },
    actionsSetSelectedBarGroupName ({ commit }, id) {
      commit('setSelectedBarGroupName', id);
    },
  },
};
